import { Spinner, Stack } from '@agentisai/design-system';

/**
 * CallbackPage — the Auth0 redirect_uri target (/callback). Auth0Provider
 * handles the ?code&state exchange; this element only prevents a 404 flash
 * while that runs. onRedirectCallback navigates away when the exchange
 * resolves. Public — never guarded (isAuthenticated is false mid-exchange).
 */
export function CallbackPage() {
  return (
    <Stack as="main" align="center" justify="center" style={{ minHeight: '60vh' }}>
      <Spinner size="lg" tone="primary" label="Signing you in…" />
    </Stack>
  );
}
CallbackPage.displayName = 'CallbackPage';
